<div class="country-page">
  <div class="flex justify-content-end mt-3">
    <div>
      <div class="total">Total Countries({{ countryTotalRecords }})</div>
    </div>
    <div class="filter-action-row">
      <button pButton type="button" label="Save" class="" (click)="Add()">
        Add
      </button>
    </div>
  </div>
  <app-table
    [data]="countryData"
    [columns]="countryColumns"
    [rows]="countryPageSize"
    [showPaginator]="true"
    [showSort]="false"
    [showFilter]="false"
    [loading]="countryLoading"
    [globalFilterFields]="countryGlobalFilterFields"
    [actions]="countryActions"
    [totalRecords]="countryTotalRecords"
    [hideTableHeader]="true"
    (lazyLoadData)="onLazyLoadEventFromTable($event)"
  >
  </app-table>
</div>

<app-add-country [visible]="openModal" [data]="editData" (closeDialog)="closeDialog($event)" [editMode]="editMode" ></app-add-country>
